












import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import TemplatesList from "@/views/TemplatesList.vue";
import ConfigurationScene from "@/views/ConfigurationScene.vue";
import Loading from "@/components/loading/Loading.vue";
import TemplatesModule from "@/store/modules/templates";
import Template from "@/models/template";

@Component({
  components: {
    TemplatesList,
    ConfigurationScene,
    Loading
  },
  name: "App"
})
export default class Configurator extends Vue {
  public loadingMessages: string[] = [];
  public loadingCanCancel: boolean = false;

  get isLoading() {
    return this.loadingMessages.length !== 0;
  }

  get loadingMessage() {
    return this.loadingMessages[0];
  }

  get templateChooseStep(): boolean {
    return TemplatesModule.selectedTemplate == null;
  }

  private onBackPressed() {
    TemplatesModule.setSelectedTemplate(null);
  }

  private onLoadingChanged(message: string, loading: boolean) {
    const index = this.loadingMessages.indexOf(message);

    if (loading) {
      if (index < 0) {
        this.loadingMessages.push(message);
      }
    } else {
      this.loadingMessages.splice(index, 1);
    }
  }
}
